import { Box, Chip } from '@montugroup/design-system';
import { styled, svgIconClasses } from '@mui/material';

export const ReviewNewScriptCardRoot = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.action.disabledBackground,
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignContent: 'flex-start',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(2),
}));

export const Instructions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
}));

export const AvailableInstructions = styled(Instructions)(({ theme }) => ({
  backgroundColor: theme.palette.success.light,
  [`& .${svgIconClasses.root}`]: {
    color: theme.palette.success.main,
  },
}));

export const OutOfStockInstructions = styled(Instructions)(({ theme }) => ({
  color: theme.palette.warning.main,
  backgroundColor: theme.palette.warning.light,
  [`& .${svgIconClasses.root}`]: {
    color: theme.palette.warning.main,
  },
}));

export const ProductStatusChip = styled(Chip)(() => ({
  fontWeight: 600,
}));

export const AvailableProductStatusChip = styled(ProductStatusChip)(({ theme }) => ({
  color: theme.palette.success.main,
  backgroundColor: theme.palette.success.light,
  border: `1px solid ${theme.palette.success.main}`,
}));

export const OutOfStockStatusChip = styled(ProductStatusChip)(({ theme }) => ({
  color: theme.palette.warning.main,
  backgroundColor: theme.palette.warning.light,
  border: `1px solid ${theme.palette.warning.main}`,
}));
